import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';
import { useRestoreAllTicketModal } from './use-restore-all-ticket-modal';

export type TRestoreAllTicketModalType = 'RestoreAllTicketModal';
export interface IRestoreAllTicketModalProps {
  spaceId: string;
  spaceColumnId: string;
  onSuccess?: () => Promise<void> | void;
}

const RestoreAllTicketModal = memo(({ spaceId, spaceColumnId, onSuccess }: IRestoreAllTicketModalProps) => {
  const {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  } = useRestoreAllTicketModal({
    spaceId,
    spaceColumnId,
    onSuccess,
  });

  // RENDER
  return (
    <Modal
      isOpen={isOpen}
      lockBodyScroll
      onClose={handleCloseModal}
      isCloseOutside={false}
      className="md:w-[500px] w-[345px] p-[24px]"
    >
      <ModalHeader>
        <ModalTitle>Are you sure you want to restore all tickets in this column?</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="restore-all-ticketing-ticket-form"
          className="grid gap-[16px] mt-[16px]"
        >
          <span className="text-[14px] font-normal text-[#9D9D9C]">
            All tickets in this column will be restored to your active list and can be updated again.
          </span>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCancelModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="restore-all-ticketing-ticket-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner className="w-[18px] h-[18px]" /> : null} Restore All
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
RestoreAllTicketModal.displayName = 'RestoreAllTicketModal';
export default RestoreAllTicketModal;
